import React from 'react';
import Barra from './barra';
import './App.css';

const socialLinks = [
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    text: 'Conversemos',
    href: 'https://wa.me/573146148505',
    icon: '/images/svg/whatsapp.svg',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    text: 'Mira mi contenido',
    href: 'https://www.instagram.com/johnatan_mena/profilecard/?igsh=MWZ5MWZ5eXk1NTZmNQ==',
    icon: '/images/svg/instagram.svg',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    text: 'Perfil profesional',
    href: 'https://www.linkedin.com/in/johnatan-mena-524793203/',
    icon: '/images/svg/linkedin.svg',
  },
];

const highlights = [
  'Software',
  'IoT',
  'Biomedica',
  'Consultoria TI',
];

function Inicio() {
  return (
    <div className="page-shell">
      <Barra />

      <main>
        <section className="hero-section">
          <div className="hero-content">
            <p className="eyebrow">Ingenieria aplicada a soluciones reales</p>
            <h1>Johnatan Mena Salcedo</h1>
            <p className="hero-lead">
              Ingeniero de Software y Biomédico, especialista en IoT y consultoría TI. Diseño y construyo soluciones digitales e inteligentes que conectan procesos, activos y decisiones para impulsar resultados de negocio.
            </p>
            <div className="hero-actions">
              <a className="primary-action" href="/contenido">Ver contenido</a>
              <a className="secondary-action" href="/curriculum">Ver curriculum</a>
            </div>
            <div className="hero-tags" aria-label="Areas de experiencia">
              {highlights.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div>

          <div className="hero-media" aria-label="Video de presentacion">
            <video
              controls
              autoPlay
              muted
              loop
              playsInline
              poster="/images/png/mena.png"
            >
              <source src="https://corpstudios.s3.us-east-1.amazonaws.com/videoresume.mp4" type="video/mp4" />
            </video>
          </div>
        </section>

        <section className="social-section" aria-label="Redes de contacto">
          {socialLinks.map((link) => (
            <a
              className="social-card"
              href={link.href}
              id={link.id}
              key={link.id}
              rel="noreferrer"
              target="_blank"
              title={link.label}
            >
              <span className="social-icon">
                <img src={link.icon} alt="" aria-hidden="true" />
              </span>
              <span>
                <strong>{link.label}</strong>
                <small>{link.text}</small>
              </span>
            </a>
          ))}
        </section>
      </main>

      <footer className="site-footer">
        <div className="footer-inner">
          <div>
            <p className="eyebrow">Hagamoslo real</p>
            <h2>Transformemos ideas en productos utiles.</h2>
          </div>

          <div className="footer-grid">
            <div>
              <h3>Contacto</h3>
              <p>johnatanmenasalcedo@gmail.com</p>
              <p>3146148505</p>
            </div>
            <div>
              <h3>BIT</h3>
              <p>www.beaconsiottechnologies.com</p>
              <p>beaconsiottechnologies@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="copy">2026, &copy; Johnatan Mena</div>
      </footer>
    </div>
  );
}

export default Inicio;
